import styled from 'styled-components';

export const StyledPatientUnconfirmedForm = styled.div`
   padding-right: 12px;
   display: flex;
   flex-direction: column;
   gap: 40px;
   width: 100%;
`;
StyledPatientUnconfirmedForm.displayName = 'StyledPatientUnconfirmedForm';
